<form class="example-form">
    <mat-form-field class="example-full-width">
        <input matInput placeholder="Nombre" [formControl]="borradorFormControl" [errorStateMatcher]="matcher">
        <mat-hint>Ingresa un nombre al borrador</mat-hint>
        <mat-error *ngIf="borradorFormControl.hasError('required')">
            El nombre es <strong>obligatorio</strong>
        </mat-error>
    </mat-form-field>
</form>
<button matDialogClose mat-raised-button color="warn" class="spacer">Cancelar</button>
<button mat-raised-button color="primary" class="spacer" (click)="saveDraft()">Guardar Borrador</button>